import { createContext, useContext } from 'react';
import type { EditorModel } from './types';

export const EditorModelContext = createContext<EditorModel | null>(null);

export const useEditorModel = () => {
  const context = useContext(EditorModelContext);
  return context;
};
